import * as schema from "@/shared/state/visualization/schema/v1/three-d";

import { BabylonState } from "../../state";

import { updateEntities } from "./updateEntities";
import { updateSceneConfig } from "./updateSceneConfig";

/**
 * Synchronizes the babylon state with the incoming panelState.
 */
export function onSetState(
  state: BabylonState,
  panelState: { config?: schema.PanelConfig; data: schema.PanelData },
) {
  updateEntities(state, panelState.data);
  // The scene config includes references to entity IDs,
  // so make sure the entities are updated first.
  updateSceneConfig(state, panelState.config);
}
